import { UserSearchDto } from '../shared/dto/user-search.dto';
import {
  Component,
  OnInit,
  AfterViewChecked,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  forwardRef,
  Provider,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserRead } from '../shared/user-read.model';
import { UserService } from '../shared/user.service';
import {
  NumberValueAccessor,
  CreateNumberValueAccessorProvider,
  CreateNumberValueValidationProvider,
} from '../../shared/widgets/value-accessors/number-value-accessor';

@Component({
  selector: 'wl-user-selector',
  templateUrl: 'user-selector.component.html',
  styleUrls: ['user-selector.component.css'],
  providers: [
    UserService,
    CreateNumberValueAccessorProvider(UserSelectorComponent),
    CreateNumberValueValidationProvider(UserSelectorComponent),
  ],
  standalone: false
})
export class UserSelectorComponent extends NumberValueAccessor implements OnInit {
  //for validation to know if 0 an be allowed
  @Input() required: any;
  @Input() noneText: string;
  @Input() includeInactive: boolean = false;

  @Output() selectedUserNumChange = new EventEmitter<number>();
  @Output() selectedUserChanged = new EventEmitter<UserRead>();

  public _lastValue: number;

  public _allUsers: Array<UserRead> = [];
  public users: Array<UserRead> = [];

  public constructor(public _translateService: TranslateService, public _userService: UserService) {
    super();
    this.noneText = '';
  }

  /**
   * called when changed from the outside
   * @param value
   */
  writeValue(value: number) {
    super.writeValue(value);
    this.resetUserList();
  }

  //this overrides the base class function to set
  //what it means for this this control to be valid
  isValid = (): boolean => {
    if (this.required == true) {
      if (this.value > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  ngOnInit() {
    this.loadUsers();
  }
  ngOnChanges(changes: SimpleChanges) {}

  onUserChange(data: string) {
    this.emitOutputObject();
  }

  loadUsers = (): void => {
    this._userService.search({ PageNumber: 0, PageSize: 0, OrderBy: 'UserName' } as UserSearchDto).then((data) => {
      this._allUsers = data && data.Result ? data.Result : [];
      this.resetUserList();
    });
  };

  emitOutputObject = (): void => {
    this.selectedUserNumChange.emit(this.value);

    //get selected user
    for (let user of this.users) {
      if (this.value == user.UserNum) {
        this.selectedUserChanged.emit(user);
        break;
      }
    }
  };

  /**
   * updates the list based on input
   */
  public resetUserList() {
    if (this.includeInactive) this.users = this._allUsers;
    else this.users = this._allUsers.filter((x) => !x.Inactive || x.UserNum == this.value);
  }
}
